import { Injectable } from '@angular/core';

@Injectable()
export class PoDataTransferServiceService {

  constructor(
  ) { }

  private data;

  setData(data){
    this.data = data?data:[];
    // put this value in local storage
    // localStorage.setItem('po_data', JSON.stringify(data));
  }

  getData(){
    let temp = this.data?this.data:[];
   // this.clearData();
    // if local storage is not empty then return the value from local storage
    // if(localStorage.getItem('po_data')){
    //   return JSON.parse(localStorage.getItem('po_data'));
    // }
    return temp;
  }

  clearData(){
    // this.data = [];
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src1176570514/src/src/app/shared/services/po-data-transfer-service.service.ts